var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c("actionBarComponent", {
        attrs: {
          title: _vm.$t(
            "__.Components.parent.informacoesAdicionaisRepresentante.edit_vue_html.titulo"
          ),
        },
        on: { onSave: _vm.save },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("tipoCadastro"),
                        expression: "errors.first('tipoCadastro')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "tipoCadastro",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.ts.cliente")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "tipoCadastro",
                        name: "tipoCadastro",
                        data: _vm.tipoCadastroOptions,
                        searchable: false,
                      },
                      model: {
                        value: _vm.model.tipoCadastro,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "tipoCadastro", $$v)
                        },
                        expression: "model.tipoCadastro",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-9" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.model.tipoCadastro == 1,
                        expression: "model.tipoCadastro == 1",
                      },
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("clienteId"),
                        expression: "errors.first('clienteId')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "clienteId",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.ts.cliente")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("search-combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "clienteId",
                        name: "clienteId",
                        actionName: "clientes",
                        addNew: false,
                        advancedSearch: true,
                        filterable: false,
                        advancedSearchCampos: [
                          { campo: "text", descricao: "Nome" },
                          { campo: "cpf", descricao: "CNPJ/CPF" },
                          { campo: "celular", descricao: "Celular" },
                        ],
                        customComboText: _vm.customComboTextCliente,
                        customView: true,
                        propDescription: "nome",
                        service: "Cliente",
                      },
                      model: {
                        value: _vm.model.registroId,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "registroId", $$v)
                        },
                        expression: "model.registroId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.model.tipoCadastro == 2,
                        expression: "model.tipoCadastro == 2",
                      },
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("prescritorId"),
                        expression: "errors.first('prescritorId')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "prescritorId",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.ts.prescritor")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("search-combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "prescritorId",
                        name: "prescritorId",
                        actionName: "prescritores",
                        addNew: false,
                        advancedSearch: true,
                        advancedSearchCampos: [
                          { campo: "text", descricao: "Nome" },
                          {
                            campo: "numeroRegistro",
                            descricao: "Número de registro",
                          },
                          {
                            campo: "tipoConselhoRegionalDescricao",
                            descricao: "Conselho Regional",
                          },
                          { campo: "cpf", descricao: "CNPJ/CPF" },
                        ],
                        customComboText: _vm.customComboTextPrescritor,
                        customView: true,
                        propDescription: "nome",
                        service: "Prescritor",
                      },
                      model: {
                        value: _vm.model.registroId,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "registroId", $$v)
                        },
                        expression: "model.registroId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("texto"),
                        expression: "errors.first('texto')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "texto" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.ts.descricao")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "texto", name: "texto", rows: 3 },
                      model: {
                        value: _vm.model.texto,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "texto", $$v)
                        },
                        expression: "model.texto",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "submit" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-save",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.salvar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }